var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61.5,
    r: 36.2188,
    fill: "#0EAB44",
    stroke: "black",
    strokeWidth: 1.90625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0379 50.4621C75.87 51.107 76.0218 52.3044 75.3769 53.1366L60.6035 72.1991C60.286 72.6087 59.8154 72.8714 59.3001 72.9267C58.7849 72.982 58.2693 72.8251 57.8721 72.4922L46.9112 63.3038C46.1044 62.6275 45.9986 61.4252 46.6749 60.6183C47.3513 59.8115 48.5536 59.7058 49.3604 60.3821L58.8034 68.298L72.3634 50.8011C73.0083 49.969 74.2057 49.8172 75.0379 50.4621Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5938 62.4515C28.5938 51.0567 34.4748 41.0356 43.3672 35.2578",
    stroke: "white",
    strokeWidth: 1.90625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.d02b80e239f994c15ce0e1ce8016d2a6.svg";
export { ForwardRef as ReactComponent };